<template>
  <div class="content " ref="scrollContainer">
    <!-- <div class="zhanweilayout"></div> -->
    <van-sticky>
      <div class="headnav">
        <div class="headleftbox">
          <img class="searchicon" src="../assets/imgs/sousuo@3x.png" alt @click="openSearchOverlay" />
          <img class="caricon" src="../assets//imgs//cart.png" style="margin-left: 10px;" alt="" @click="toCart">
        </div>
        <!-- <div @click="openLoginDia('login')" v-if="!isLogin">登录</div>
        <div @click="loginOutFn" v-else-if="isLogin">退出</div>
        <div v-if="!isLogin" @click="openLoginDia('jion')">加入我们</div>
        <div v-else-if="isLogin" @click="toVipPage">设置</div>
        <div @click="toCart">购物车</div>
        <div @click="toOrderList">订单</div>-->

        <div class="logobox">
          <img class="logoimg" @click="changeCategory('')" src="../assets/imgs/logo@3x.png" alt />
        </div>
        <div>
          <div style="width: 41px;text-align: right;"><img class="menuicon" src="../assets/imgs/bar-zhankai@3x.png" alt
              @click="openNavOverlay" /></div>

        </div>
      </div>



    </van-sticky>
    <div class="zrl ">

      <div class="menu" @mouseenter="showMask = true" @mouseleave="showMask = false">
        <div class="menubox">
          <div>
            <div class="menu-item" style="width: 100px;" @click.stop="openmask">商品
              <div class="submenu">
                <div class="sublist" v-for="item in categoryList" :key="item.id" @click="changeCategory(item)"> {{
                  item.cateName }}</div>

              </div>
            </div>
            <div class="menu-item" @click="toCart">购物车</div>


            <div class="menu-item" @click="tomyorder">订单

            </div>
            <!-- <div class="menu-item" @click="onSearch">搜索</div> -->
            <div class="menu-item" @click="openSearchbtn">搜索</div>
          </div>
          <div>
            <div class="menu-item" style="width: 90px;" @click.stop="openmask">社区
              <div class="submenu">
                <div class="sublist" @click="toBulletinBoard">公告栏</div>
                <div class="sublist" @click="toAboutus">关于我们</div>
                <div class="sublist" @click="toPurchasenotes">购买须知</div>
                <div class="sublist" @click="toPostsalesservice">售后服务</div>
                <div class="sublist" @click="toComplaintservice">温馨提示</div>
              </div>
            </div>
            <div class="menu-item" @click="toMine" style="width: 90px;margin-right: 20px;">我的主页</div>



            <div class="menu-item" @click="showNoLogin" v-if="!isLogin">客服

            </div>
            <div class="menu-item" onclick="qimoChatClick();" v-if="isLogin">客服

            </div>
            <div class="menu-item" v-if="!isLogin" @click="openloginbtn">登录
            </div>
            <div class="menu-item" v-if="isLogin" @click="loginOutFn">退出
            </div>




            <div></div>
          </div>
        </div>


      </div>
      <div class="mask" v-show="showMask" @click="closemask"></div>
      <div class=""
        style="position: fixed;top: 12px;left: 50%;transform:translate(-50%,0);z-index: 9999999;cursor: pointer;">
        <img class="zrltoplogo" @click="changeCategory('')" src="../assets/imgs/logo@3x.png" alt />
      </div>


    </div>

    <div>
      <!-- <router-view ref="child"></router-view> -->
      <keep-alive>
        <router-view ref="child" v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view ref="child" v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <div class="lg">
      <van-overlay :show="showSearchOverlay">
        <div>
          <!-- <div class="zhanwei-search-box"></div> -->
          <div class="search-box-bg">

            <div class="search-box">
              <!-- <form action>
              <van-search
                v-model="searchValue"
                show-action
                action-text="关闭"
                placeholder="请输入搜索关键词"
                @search="onSearch"
                @cancel="onCancel"
              />
            </form>-->
              <!-- <van-form action="">
              <van-search v-model="searchValue" show-action action-text="关闭" placeholder="请输入搜索关键词" @search="onSearch"
              @cancel="onCancel" background="transparent" class="search-box-bg-input" />
            </van-form> -->

              <van-form action="">
                <van-search v-model="searchValue" show-action placeholder="请输入搜索关键词" @search="onSearch"
                  background="transparent" class="search-box-bg-input">
                  <template slot="action">
                    <div @click="onSearch">搜索</div>
                  </template>

                </van-search>
              </van-form>


              <!-- <input type="text" class="search-box-bg-input"> -->
            </div>
            <div>
              <div class="search-list-box" v-for="(item, index) in searchList" :key="index" @click="setSearchVal(item)">
                <span style="margin-left: 20px">{{ item }}</span>
              </div>
            </div>
            <div class="clearsearchbtn" @click="clearSearch">清空历史</div>
            <div class="closebox">
              <van-icon name="cross" size="20px" @click="closeSearchOverlay" />
            </div>
          </div>
        </div>
      </van-overlay>
    </div>
    <div class="zrl" v-if='showSearchOverlay'>
      <van-overlay :show="showSearchOverlay">
        <div>
          <!-- <div class="zhanwei-search-box"></div> -->
          <div class="search-box-bg">

            <div class="search-box">
              <!-- <form action>
              <van-search
                v-model="searchValue"
                show-action
                action-text="关闭"
                placeholder="请输入搜索关键词"
                @search="onSearch"
                @cancel="onCancel"
              />
            </form>-->
              <!-- <van-form action="">
              <van-search v-model="searchValue" show-action action-text="关闭" placeholder="请输入搜索关键词" @search="onSearch"
              @cancel="onCancel" background="transparent" class="search-box-bg-input" />
            </van-form> -->

              <van-form action="">
                <van-search v-model="searchValue" show-action placeholder="请输入搜索关键词" @search="onSearch"
                  background="transparent" class="search-box-bg-input">
                  <template slot="action">
                    <div @click="onSearch">搜索</div>
                  </template>

                </van-search>
              </van-form>


              <!-- <input type="text" class="search-box-bg-input"> -->
            </div>
            <div class="zrlsearchbox">
              <div class="zrlsearch-list-box" v-for="(item, index) in searchList" :key="index"
                @click="setSearchVal(item)">
                <span style="margin-left: 20px">{{ item }}</span>
              </div>
            </div>
            <div class="clearsearchbtn" @click="clearSearch">清空历史</div>
            <div class="closebox">
              <van-icon name="cross" size="20px" @click="closeSearchOverlay" />
            </div>
          </div>
        </div>
      </van-overlay>
    </div>
    <!-- <van-overlay :show="showNavOverlay" :lock-scroll="false">
      <div>
      
        <div class="nav-box-bg">
          <div class="zhanwei-nav-box"></div>
          <div class="zhanwei-nav-box2">
            <img class="navcloseimg" src="../assets/imgs/guanbi@3x.png" alt @click="closeNav" />
          </div>
          <div class="nav-logo-box">
            <img
              class="nav-logo-box"
              @click="changeCategory('')"
              src="../assets/imgs/logo1@3x.png"
              alt
            />
          </div>
          <div class="margin-top39">
            <div class>
              <div class="margin-bottom30" @click="showShop=!showShop">
                商品
                <span v-if="!showShop">+</span>
                <span v-if="showShop">-</span>
              </div>

              <div v-if="showShop" class="transitionbox">
                <div
                  class="margin-bottom30"
                  v-for="item in categoryList"
                  :key="item.id"
                  @click="changeCategory(item)"
                >{{ item.cateName }}</div>
              </div>
            </div>
          </div>
          <div class="margin-top39" @click="toVipPage">VIP</div>
          <div class="margin-top39" @click="toBulletinBoard">公告栏</div>
          <div class="margin-top39" @click="toAboutus">关于我们</div>
          <div class="margin-top100" v-if="!isLogin" @click="openLoginDia('login')">登录</div>
          <div class="margin-top39" v-if="!isLogin" @click="openLoginDia('login')">登录</div>
          <div class="margin-top39" v-if="isLogin" @click="loginOutFn">退出</div>
          <div class="margin-top39" @click="toMine">我的主页</div>
          <div class="margin-top39" @click="toOrderList">订单</div>
          <div class="margin-top39" @click="toCart">购物车</div>
          <div class="margin-top39" @click="toPurchasenotes">购买须知</div>
          <div class="margin-top39" @click="toPostsalesservice">售后服务</div>
          <div class="margin-top39" @click="toComplaintservice">投诉通道</div>
         
        </div>
      </div>
    </van-overlay> -->
    <div class="navoverlay" v-if="showNavOverlay">
      <div @click.stop>

        <div class="nav-box-bg">
          <div class="zhanwei-nav-box"></div>
          <div class="zhanwei-nav-box2">
            <img class="navcloseimg" src="../assets/imgs/guanbi@3x.png" alt @click="closeNav" />
          </div>
          <div class="nav-logo-box">
            <img class="nav-logo-box" @click="changeCategory('')" src="../assets/imgs/logo1@3x.png" alt />
          </div>
          <div class="margin-top39">
            <div class>
              <div class="margin-bottom30" @click="showShop = !showShop">
                商品
                <span v-if="!showShop">+</span>
                <span v-if="showShop">-</span>
              </div>

              <div v-if="showShop" class="transitionbox">
                <div class="margin-bottom30" v-for="item in categoryList" :key="item.id" @click="changeCategory(item)">
                  {{ item.cateName }}</div>
              </div>
            </div>
          </div>
          <div class="margin-top39" @click="toVipPage">VIP</div>
          <div class="margin-top39" @click="toBulletinBoard">公告栏</div>
          <div class="margin-top39" @click="toAboutus">关于我们</div>

          <div class="margin-top39" @click="toMine">我的主页</div>
          <div class="margin-top39" @click="toOrderList">订单</div>
          <div class="margin-top39" @click="toCart">购物车</div>
          <div class="margin-top39" @click="toPurchasenotes">购买须知</div>
          <div class="margin-top39" @click="toPostsalesservice">售后服务</div>
          <div class="margin-top39" @click="toComplaintservice">温馨提示</div>
          <div class="margin-top39" @click="showNoLogin" v-if="!isLogin">联系客服</div>
          <div class="margin-top39 po_r" v-if="isLogin">联系客服
            <button v-if="isLogin" class="footkefubtntwo" onclick="qimoChatClick();">1</button>
          </div>
          <!-- <div class="margin-top100" v-if="!isLogin" @click="openLoginDia('login')">登录</div> -->
          <div class="margin-top39" v-if="!isLogin" @click="openLoginDia('login')">登录</div>
          <div class="margin-top39" v-if="isLogin" @click="loginOutFn">退出</div>

        </div>
      </div>
    </div>
    <Logindia ref="logindia"></Logindia>
    <Cangetcoupondia ref="cangetcoupondia"></Cangetcoupondia>

    <div class="lg footkefubox">
      <img @click.stop="showNoLogin" class="footkefuimg" src="../assets/imgs/huabg.png" alt />
      <button v-if="isLogin" class="footkefubtn" onclick="qimoChatClick();">1</button>
    </div>
    <div class="zrl footkefubox" :style="modalStyle" @mousedown.stop="startDrag" @mouseup.stop="stopDrag"
      @mousemove.stop="drag">

      <img v-if="!isLogin" @click.stop="showNoLogin" class="footkefuimg" src="../assets/imgs/huabg.png" alt />
      <img v-if="isLogin" class="footkefuimg" src="../assets/imgs/huabg.png" alt />
      <button v-if="isLogin" class="footkefubtn" onclick="qimoChatClick();">1</button>

    </div>

    <van-overlay :show="showBulletinboard" :lock-scroll="false">
      <div class="bulletinboardbox">
        <!-- <div class="bulletinboardtitle">
          {{ bulletinBoardInfo.title }}
        </div> -->
        <div class="bulletinboardcontent">
          <div v-html="setImgWidth(bulletinBoardInfo.content)"></div>
        </div>
        <div class="bulletinboardfooter">
          <van-button color="#000000" @click="closeBulletinboard" v-if="userInfo.id || localUserInfo.id" icon="cross"
            icon-position="right" type="primary" size="mini">不再显示</van-button>
          <van-button color="#986665" icon="cross" icon-position="right" type="primary" size="mini"
            @click="showBulletinboard = false">关闭</van-button>
        </div>
      </div>

    </van-overlay>
    <div class="zrl" v-if="showBulletinboard">
      <el-dialog title="" style="z-index: 99;min-width: 500px;" :close-on-click-modal="true" :modal="false"
        :show-close="false" :visible.sync="showBulletinboard" top="88px" width="50%">
        <div class="zrl zrlbulletinboardcontent">
          <div v-html="setImgWidth(bulletinBoardInfo.content)"></div>
        </div>
        <span slot="footer" class="dialog-footer">
          <div class="bulletinboardfooter">
            <van-button color="#000000" @click="closeBulletinboard" v-if="userInfo.id || localUserInfo.id" icon="cross"
              icon-position="right" type="primary" size="mini">不再显示</van-button>
            <van-button color="#986665" icon="cross" icon-position="right" type="primary" size="mini"
              @click="showBulletinboard = false">关闭</van-button>
          </div>
        </span>
      </el-dialog>
    </div>

    <div class="zrl" style="position: 0;">
      <img class="zrlshangjt" @click="totop" v-show="showup" src="../assets/imgs/jiantou.png" alt="">
      <img class="zrlxiajt" @click="tobottom" v-show="!showup" src="../assets/imgs/jiantou.png" alt="">
    </div>


    <van-overlay :show="showWechat" :lock-scroll="false">
      <div class="wechatbox">
        请在右上角浏览器打开
      </div>

    </van-overlay>


  </div>
</template>

<script>
import local from "@/utils/local.js";
import Logindia from "../components/Logindia.vue";
import Cangetcoupondia from "../components/Cangetcoupondia.vue";
import session from "../utils/session";
import { categoryList_api, handerAccess_api } from "../apis/layout";
import { userInfo_api } from "../apis/mine";
import { imOrderInfo_api } from "../apis/order";
import { getNoticeList_api, bulletinBoardInfo_api } from '../apis/bulletinboard'
import { Draggable } from 'draggable-vue-directive'
export default {
  directives: {
    Draggable,
  },
  components: { Logindia, Cangetcoupondia },
  data() {
    return {
      showSearchOverlay: false,
      searchValue: "",
      searchList: [],
      showNavOverlay: false,
      isLogin: false,
      categoryList: [],
      categoryId: "",
      cangetCouponList: [],
      showShop: false,
      showWechat: false,
      showBulletinboard: false,
      bulletinBoardInfo: {
        title: "",
        author: "",
        content: "",
        isactive: "",
        scan: 0,
        sortnumber: 1,
        title: "",
        isindex: 0,
        scanback: 0,
        scanisshow: 0,
      },
      userInfo: {
        id: null
      },
      localUserInfo: {
        id: null
      },
      showMask: false,
      isTabletPortrait: '',
      showup: false,
      windowWidth: window.innerWidth,
      dragStartX: 0,
      dragStartY: 0,
      initialX: window.innerWidth - 110,
      initialY: window.innerHeight - 200,
      dragging: false,
      prevWidth: '',
      isTouchDevice: ''

    };
  },
  created() {
    if (local.get("userInfo")) {
      this.localUserInfo = JSON.parse(local.get("userInfo"))
    }
    this.getUserLogin();
    this.getCategoryList();
    this.getUserInfo();


    this.showWechat = this.isWechat()
    this.getBulletinboard()
    this.prevWidth = window.innerWidth
    //this.showWechat = true

  },
  mounted() {
    this.$bus.$on("searchCategoryInfo", e => {
      this.categoryId = e.id;
      this.$router.push(
        {
          path: "/index",
          query: {
            searchCategoryId: e.id
          }
        },
        () => { }
      );
    });
    this.$nextTick(() => {
      this.getCangetCoupon();
      this.getImOrderInfo();
      this.handleResize()
    }, 1000);



    window.addEventListener('scroll', this.handleWindowScroll)
    window.addEventListener('resize', this.handleResize);


  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleWindowScroll);
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    modalStyle() {
      return {
        top: `${this.initialY}px`,
        left: `${this.initialX}px`,
      };
    },
  },
  methods: {
    //拖拽
    startDrag(event) {
      event.preventDefault()
      event.stopPropagation()

      this.dragging = true;
      this.dragStartX = event.clientX - this.initialX;
      this.dragStartY = event.clientY - this.initialY;
      document.addEventListener('mousemove', this.drag);
      document.addEventListener('mouseup', this.stopDrag);
    },
    drag(event) {
      event.preventDefault()
      event.stopPropagation()
      if (this.dragging) {
        this.initialX = event.clientX - this.dragStartX;
        this.initialY = event.clientY - this.dragStartY;
      }
    },
    stopDrag() {

      this.dragging = false;
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    showlog() {
      console.log('登录了');
    },


    handleResize() {
      this.windowWidth = window.innerWidth;

      const currentWidth = window.innerWidth;
      // 若宽度变化超过阈值（避免误触）
      if (Math.abs(currentWidth - this.prevWidth) > 100) {
        const isLandscape = currentWidth > window.innerHeight;
        if (isLandscape) {
          this.prevWidth = currentWidth
          console.log('刷新了');
          location.reload(true);
          // 触发强制刷新‌:ml-citation{ref="5,8" data="citationList"}
        }
        this.prevWidth = currentWidth; // 更新记录值
      }


      if (this.windowWidth > 1000) {
        // 检测是否为触摸设备

        const isTouchDevice = 'ontouchstart' in window;
        this.isTouchDevice = 'ontouchstart' in window;
        console.log(isTouchDevice, 'ontouchstart');

        if (isTouchDevice) {
          const navItems = document.querySelectorAll('.menu-item');
          const navItems2 = document.querySelectorAll('.submenu');
          navItems.forEach(item => {

            item.addEventListener('click', (e) => {
              // 阻止事件冒泡（避免点击菜单外部时立即关闭）
              // e.stopPropagation();
              // 切换激活状态

              if (item.children[0]) {

                item.children[0].classList.toggle('active');
              }

            });
          });

          // 点击页面其他区域关闭菜单
          document.addEventListener('click', () => {
            navItems.forEach(item => item.classList.remove('active'));
            navItems2.forEach(item => item.classList.remove('active'));
          });
        }
      }


    },

    handleWindowScroll() {
      const { scrollY, innerHeight } = window;
      const { scrollHeight } = document.documentElement;
      // 判断是否滚动到底部（可设置阈值，如-10px）
      if (scrollY + innerHeight >= scrollHeight - 10) {
        console.log('滚动到页面底部');
        this.showup = true
      } else {
        this.showup = false
      }
    },
    totop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    tobottom() {
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer;
        // 平滑滚动到底部
        window.scrollTo({
          top: container.scrollHeight,
          behavior: 'smooth'
        });
      });
    },


    openmask() {
      const isTouchDevice = 'ontouchstart' in window;
      if (isTouchDevice) {
        this.showMask = true
      }

    },
    closemask() {
      this.showMask = false
      const navItems = document.querySelectorAll('.submenu');
      const navItems2 = document.querySelectorAll('.menu-item');
      navItems2.forEach(item => item.classList.remove('active'));
      navItems.forEach(item => {
        console.log(item);
        item.classList.remove('active')
      });



    },
    openloginbtn() {
      setTimeout(() => {
        if (this.isTouchDevice) {
          this.closemask()
        }

      }, 500);
      this.openLoginDia("login");
    },
    isWechat() {
      var ua = window.navigator.userAgent.toLowerCase();
      console.log(ua)
      if (ua.match(/micromessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    },

    openSearchOverlay() {
      if (local.get("searchList")) {
        this.searchList = JSON.parse(local.get("searchList"));
      }
      this.showSearchOverlay = true;
    },
    openSearchbtn() {
      this.showSearchOverlay = true
      this.openSearchOverlay()
      setTimeout(() => {
        if (this.isTouchDevice) {
          this.closemask()
        }

      }, 500);
    },


    onSearch(val) {
      console.log(val)
      console.log(this.searchValue)


      if (this.searchValue) {
        if (local.get("searchList")) {
          let searchList = JSON.parse(local.get("searchList"));
          searchList.unshift(this.searchValue);

          let newSearchList = JSON.stringify(Array.from(new Set(searchList)));
          local.set("searchList", newSearchList);
        } else {
          local.set("searchList", "[]");
          let searchList = [];
          searchList.unshift(this.searchValue);
          let newSearchList = JSON.stringify(Array.from(new Set(searchList)));
          local.set("searchList", newSearchList);
        }
      }

      this.showSearchOverlay = false;

      //console.log(this.$route.path=='/index')
      if (this.$route.path == "/index") {
        //  this.$parent.searchData.key=val
        this.$refs.child.searchFntwo(this.searchValue);
      } else {
        this.$router.push(
          {
            path: "/index",
            query: {
              searchValue: this.searchValue
            }
          },
          () => { }
        );
      }
    },
    setSearchVal(val) {
      this.searchValue = val;
    },
    onCancel() {
      this.showSearchOverlay = false;
    },
    closeSearchOverlay() {
      this.showSearchOverlay = false;
    },
    clearSearch() {
      this.searchList = [];
      if (local.get("searchList")) {
        local.remove("searchList");
      }
    },
    openNavOverlay() {
      this.showNavOverlay = true;
    },
    closeNav() {
      this.showNavOverlay = false;
    },
    openLoginDia(type) {
      this.showNavOverlay = false;
      this.$refs.logindia.open(type);
    },
    toCart(val) {
      if (this.isLogin) {
        this.$router.push(
          {
            path: "/cart",
            query: {
              searchValue: val
            }
          },
          () => { }

        );

      } else {
        this.openLoginDia("login");

      }
      this.showNavOverlay = false;
      setTimeout(() => {
        if (this.isTouchDevice) {
          this.closemask()
        }

      }, 500);
    },
    toMine(val) {
      if (this.isLogin) {
        this.$router.push(
          {
            path: "/mine",
            query: {
              searchValue: val
            }
          },
          () => { }
        );
      } else {
        this.openLoginDia("login");
      }

      this.showNavOverlay = false;
      setTimeout(() => {
        if (this.isTouchDevice) {
          this.closemask()
        }

      }, 500);

    },
    toOrderList(val) {
      if (this.isLogin) {
        this.$router.push(
          {
            path: "/orderlist",
            query: {
              searchValue: val
            }
          },
          () => { }
        );
      } else {
        this.openLoginDia("login");
      }

      this.showNavOverlay = false;
    },
    toBulletinBoard() {

      setTimeout(() => {
        if (this.isTouchDevice) {
          this.closemask()
        }

      }, 500);
      this.$router.push(
        {
          path: "/bulletinboard"
        },
        () => { }
      );
      this.showNavOverlay = false;
    },
    getUserLogin() {
      if (local.get("tk") || session.get("tk")) {
        this.isLogin = true;
        this.getUserInfo();
      } else {
        this.handerAccess()
      }
    },
    async getUserInfo() {
      let { code, data } = await userInfo_api();
      if (code == 0) {
        this.$bus.$emit("userInfo", data);
        local.set("userInfo", JSON.stringify(data));
        this.userInfo = data
        window.qimoClientId.userId = data.id;
        if (data.nickName) {
          window.qimoClientId.nickName = data.nickName;
        } else {
          window.qimoClientId.nickName = data.telephone;
        }
        this.handerAccess(data.id)
      }
    },
    async handerAccess(id) {
      let accessId = id ? id : ''
      let { code, data } = await handerAccess_api({
        id: accessId
      });
      if (code == 0) {
        console.log("indexAccess");
      }
    },
    loginOutFn() {
      setTimeout(() => {
        if (this.isTouchDevice) {
          this.closemask()
        }

      }, 500);

      this.$dialog
        .confirm({
          title: "提示",
          message: "确定退出登录吗？"
        })
        .then(() => {
          if (local.get("tk")) {
            local.remove("tk");
          }
          if (session.get("tk")) {
            session.remove("tk");
          }
          local.clear();
          session.clear();

          this.isLogin = false;
          this.$router.push(
            {
              path: "/index"
            },
            () => { }
          );
        })
        .catch(() => {
          console.log("取消了");
        });
      this.showNavOverlay = false;
    },
    async getCategoryList() {
      let { code, data } = await categoryList_api();
      if (code == 0) {
        this.categoryList = data;
      }
    },
    changeCategory(item) {
      // setTimeout(() => {
      //   this.closemask()
      // }, 500);
      this.categoryId = item.id;
      this.$bus.$emit("searchCategoryInfo", item);
      if (this.$route.path == "/index") {
        // console.log('走的这里1');
        this.$nextTick(() => {
          console.log(this.$refs);
          this.$refs.child.searchFnThree(item.id);
        })

      } else {
        // console.log('走的这里2');
        this.$router.push(
          {
            path: "/index",
            query: {
              searchCategoryId: item.id
            }
          },
          () => { }
        );
      }

      this.showNavOverlay = false;
    },
    toVipPage(val) {
      setTimeout(() => {
        if (this.isTouchDevice) {
          this.closemask()
        }

      }, 500);
      if (this.isLogin) {
        this.$router.push(
          {
            path: "/vippage",
            query: {
              searchValue: val
            }
          },
          () => { }
        );
      } else {
        // this.$dialog.alert({
        //   message: "你还不是会员"
        // });
        this.openLoginDia("login");
      }
      this.showNavOverlay = false;
    },

    tomyorder() {
      setTimeout(() => {
        if (this.isTouchDevice) {
          this.closemask()
        }

      }, 500);
      if (this.isLogin) {
        this.$router.push(
          {
            path: "/orderlist",
            query: {
              type: '',
            },
          },
          () => { }
        );
      } else {
        // this.$dialog.alert({
        //   message: "你还不是会员"
        // });
        this.openLoginDia("login");
      }
    },
    showNoLogin() {
      setTimeout(() => {
        if (this.isTouchDevice) {
          this.closemask()
        }

      }, 500);
      this.$dialog.alert({
        message: "请先登录！"
      });
    },
    toPurchasenotes() {
      this.showNavOverlay = false;
      this.$router.push(
        {
          path: "/purchasenotes"
        },
        () => { }
      );
    },
    toPostsalesservice() {
      this.showNavOverlay = false;
      this.$router.push(
        {
          path: "/postsalesservice"
        },
        () => { }
      );
    },
    toComplaintservice() {
      this.showNavOverlay = false;
      this.$router.push(
        {
          path: "/complaintservice"
        },
        () => { }
      );
    },
    toAboutus() {
      this.showNavOverlay = false;
      this.$router.push(
        {
          path: "/aboutus"
        },
        () => { }
      );

    },
    async getCangetCoupon() {
      console.log('991')
      this.$refs.cangetcoupondia.open();
    },
    async getImOrderInfo() {
      let imOrderId = null;
      this.$bus.$on("imOrderId", data => {
        imOrderId = data;
      });
      let { code, data } = await imOrderInfo_api({
        id: imOrderId
      });
      if (code == 0) {
        console.log(data);
        if (!data.id) {
          m7ProductInfo.visible = false;
        } else {
          m7ProductInfo.title = data.productList[0].productName;
          m7ProductInfo.img = data.productList[0].productMainImage;
          m7ProductInfo.price = "￥" + data.totalAmount;
          m7ProductInfo.attr_one = {
            color: "#000000",
            content: `X${data.num}`
          };
          let attrTwo = null;
          if (data.status == 0) {
            attrTwo = "待付款 ";
          } else if (data.status == 1) {
            attrTwo = "待发货 ";
          } else if (data.status == 2) {
            attrTwo = "待收货 ";
          } else if (data.status == 3) {
            attrTwo = "确认收货 ";
          } else if (data.status == 4) {
            attrTwo = "售后 ";
          } else if (data.status == 5) {
            attrTwo = "已取消 ";
          }
          m7ProductInfo.attr_two = { color: "#000000", content: attrTwo };
          m7ProductInfo.other_title_one = `订单号:${data.orderNum}`;
          m7ProductInfo.other_title_two = `下单时间:${data.createTime}`;
          console.log(m7ProductInfo);
        }
      }
    },
    getBulletinboard() {
      getNoticeList_api({
        userId: this.userInfo.id || this.localUserInfo.id || '',
      }).then(res => {
        if (res.code == 0 && res.data) {
          this.bulletinBoardInfo = res.data;
          this.showBulletinboard = true
        } else {
          this.showBulletinboard = false
        }
      })
    },
    closeBulletinboard() {
      bulletinBoardInfo_api({
        id: this.bulletinBoardInfo.id,
        userId: this.userInfo.id || this.localUserInfo.id || '',
      })
        .then(res => {
          if (res.code == 0) {
            this.showBulletinboard = false
          }
        })

    },
    setImgWidth(htmlContent) {
      return htmlContent.replace(/<img/gi, '<img width="100%"');
    }
  },

  watch: {
    $route(route) {
      console.log(route);

      setTimeout(() => {
        if (this.isTouchDevice) {
          this.showMask = false
        }

      }, 500);


    }
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  min-height: 100vh;

  background: #eeeee2;
}

.zhanweilayout {
  width: 100%;
  height: 87px;
}

.headnav {
  padding: 0px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 28px;
  font-family: PingFang;
  font-weight: 600;
  color: #333333;
  background: #eeeee2;
  height: 100px;
}

.headleftbox {
  display: flex;

  align-items: center;
}

.searchicon {
  width: 26px;
  height: 26px;
  position: relative;
  top: 3px;
}

.caricon {
  width: 32px;
  height: 32px;
}

.menuicon {
  width: 28px;
  height: 28px;
  position: relative;
  top: 5px;
}

.search-box-bg {
  width: 750px;
  // background-color: rgba(255, 255, 255, 0.3);
  background-color: #eeeee2;
  height: 100vh;
  position: relative;
}

.closebox {
  position: absolute;
  right: 50px;
  top: 50px;

}

.search-box {
  margin: 0 auto;
  width: 690px;

}

.zhanwei-search-box {
  width: 750px;
  height: 10vh;
}

.search-list-box {
  margin: 0 auto;
  width: 690px;
  height: 80px;
  line-height: 80px;
  border-bottom: 1px solid #dddddd;
  color: #ccc;
}

.search-box-bg-input {
  background-color: #eeeee2;
  padding-top: 30vh;


}

.van-field__control {
  color: #ccc;
}

.van-cell__value--alone {
  color: #ccc !important;
}

.van-search__content {
  // background-color: #eeeee2;
  background-color: transparent;
  border-bottom: #333333 1px solid;
  color: #eee;
}

.clearsearchbtn {
  margin: 0 auto;
  margin-top: 22px;

  width: 142px;
  height: 62px;
  // background: #ffffff;
  // border: 2px solid #e3e3e3;
  line-height: 62px;
  text-align: center;
  font-size: 24px;
  font-family: PingFang;
  font-weight: 500;
  color: #ccc;
}

.zhanwei-nav-box {
  height: 80px;
  width: 100%;
}

.nav-box-bg {
  margin-left: 350px;
  width: 400px;
  // height: calc(100vh - 80px);
  height: 100vh;
  background: #986665;

  font-size: 28px;
  font-family: PingFang;
  font-weight: 600;
  color: #ffffff;
  box-sizing: border-box;
  padding: 0px 40px 80px;
  // overflow-y: auto;
  overflow-y: auto;
}

.navoverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
}

.nav-logo-box {
  width: 130px;
  height: 48px;
  margin: 0 auto;
}

.zhanwei-nav-box2 {
  height: 70px;
  width: 100%;
  position: relative;
}

.navcloseimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 31px;
  right: 0px;
}

.margin-top39 {
  margin-top: 39px;
}

.padding-left40 {
  margin-left: 40px;
}

.margin-left167 {
  margin-left: 167px;
}

.margin-left87 {
  margin-left: 87px;
}

.margin-left85 {
  margin-left: 85px;
}

.margin-left96 {
  margin-left: 96px;
}

.margin-left88 {
  margin-left: 88px;
}

.margin-top53 {
  margin-top: 53px;
}

.margin-bottom30 {
  margin-bottom: 30px;
  // text-align: center;
}

.margin-top70 {
  margin-top: 50px;
  text-align: center;
}

.kefuicon {
  width: 24px;
  height: 24px;
  display: inline;
  position: relative;
  top: 5px;
}

.margin-top40 {
  margin-top: 20px;
  text-align: center;
}

.margin-left10 {
  margin-left: 10px;
}

.morbtn {
  position: relative;
  top: -34px;
  opacity: 0;
}

.textcenter {
  text-align: center;
}

.logoimg {
  width: 130px;
  height: 48px;
}

.footkefubox {
  position: fixed;
  bottom: 250px;
  right: 14px;
  width: 88px;
  height: 88px;
  background-color: #fff;
  border-radius: 30px;
  box-sizing: border-box;
  padding: 10px;
}

.footkefuimg {
  width: 68px;
  height: 68px;
}

.footkefubtn {
  width: 88px;
  height: 88px;
  position: absolute;
  left: 0px;
  top: 0px;
  opacity: 0;
}

.shoptitle {
  text-align: center;
}

.margin-top100 {
  margin-top: 100px;
}

.transitionbox {
  transition: all 2s ease-in-out;
  font-size: 24px;
}

.po_r {
  position: relative;
}

.footkefubtntwo {
  position: absolute;
  left: 0px;
  top: 0px;
  opacity: 0;
  width: 320px;
  height: 40px;

}

.wechatbox {
  text-align: center;
  height: 100vh;
  font-size: 50px;
  font-weight: 600;
  color: #fff;
  padding-top: 30vh;
}

.bulletinboardbox {
  margin: 0 auto;
  width: 690px;
  background-color: #fff;
  padding-top: 50px;
  z-index: 101;
}

.bulletinboardtitle {
  font-size: 28px;
  font-family: PingFang;
  font-weight: 500;
  color: #333333;
  text-align: center;
}

@media screen and (max-width: 750px) {
  .bulletinboardcontent {
   margin-top: 58px;
    max-height: 900px;
    overflow-y: auto;
    padding:0 20px;

  }
}

@media screen and (min-width: 750px) {
  .bulletinboardcontent {
    margin-top: 58px;
    max-height: 500px;
    overflow-y: auto;
    padding: 20px 100px;

  }


}

.bulletinboardfooter {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 10px;
  padding-right: 10px;
}

.zrl {
  display: none;
  height: 88px;


  .menu {
    position: fixed;
    width: 100%;
    z-index: 999999;
    height: 88px;
    background-color: #eeeee2;
  }

  .menubox {
    display: flex;
    justify-content: space-between;
  }

  .menu-item {
    width: 90px;
    position: relative;
    display: inline-block;
    line-height: 80px;

    text-align: left;
    cursor: pointer;
    padding-left: 20px;
    box-sizing: border-box;
    /* 或其他布局方式，如 flex */
  }

  .submenu {
    width: 100%;
    display: none;
    position: absolute;
    top: 80px;
    /* 相对于父元素定位 */
    left: 50%;
    transform: translateX(-50%);
    background-color: transparent;

    z-index: 1000999;
    /* 确保子菜单在其他内容之上 */
    flex-direction: column;
    align-content: center;

    transform-style: preserve-3d;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s, visibility 0.3s;

    .sublist {
      // color: #dfdfdf;
      color: #fff;
      display: block;
      cursor: pointer;
      margin: 15px 0;
      line-height: 0;
      font-size: 11px;
      opacity: 0;
      text-align: left;
      padding-left: 20px;
      transform:
        rotateX(-90deg) translateZ(-20px);
      animation: subMenuUnfold 0.4s ease forwards;
    }

    .sublist:hover {
      color: #dfdfdf;
      //color: #fff;
    }
  }

  .mask {

    background: rgba(59, 59, 57, 0.7);
    position: fixed;
    top: 0;
    width: 100%;
    height: calc(100vh);
    z-index: 99999;
  }

  .zrlsearchbox {
    height: 400px;
    overflow-y: scroll;

  }

  .zrlsearchbox {
    height: 400px;
    overflow: auto;
    /* 隐藏滚动条样式 */
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE/Edge */
  }

  .zrlsearchbox::-webkit-scrollbar {
    width: 0;
    /* 通过宽度为0隐藏滚动条（Chrome/Safari/Edge） */
  }

  .zrlsearch-list-box {
    margin: 0 auto;
    width: 90%;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #dddddd;
    color: #ccc;
  }


  /* PC端：hover触发 */
  @media (hover: hover) {
    .menu-item:hover .submenu {
      display: flex;
      /* 当鼠标悬停在菜单项上时显示子菜单 */
      opacity: 1;
      visibility: visible;
    }
  }

  /* 平板端：点击触发 */
  @media (hover: none) {
    .submenu {
      display: none;

    }

    .submenu.active {
      display: flex;
      /* 当鼠标悬停在菜单项上时显示子菜单 */
      opacity: 1;
      visibility: visible;
    }
  }

  .menu-item:hover.menu-item {
    color: #fff;
  }



  @keyframes subMenuUnfold {
    0% {
      opacity: 0;
      transform:
        rotateX(-90deg) translateZ(-50px);
    }

    100% {
      opacity: 1;
      transform:
        rotateX(0) translateZ(0);
    }
  }

  .zrltoplogo {
    max-width: 145px;
    max-height: 54px;
  }


}

// /deep/.el-dialog__wrapper {
//   z-index: 999999 !important;

// }

.zrlshangjt {

  position: fixed;
  right: -6px;
  bottom: 10px;
  width: 40px;
  height: 40px;
}

.zrlxiajt {
  position: fixed;
  right: -6px;
  bottom: 10px;
  width: 40px;
  height: 40px;
  transform: rotate(180deg);
}

.lg {
  display: block;
}

@media screen and (min-width: 1000px) {
  .headnav {
    display: none;
  }

  .lg {
    display: none;
  }

  .zrl {
    display: block,
  }

  .footkefubox {
    bottom: 10px;
    width: 70px;
    height: 70px;
    padding: 11px;

  }

  .footkefubtn {
    width: 50px;
    height: 50px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .footkefuimg {
    width: 50px;
    height: 50px;
  }

  .bulletinboardbox {
    display: none;
  }

  .zrlbulletinboardcontent {
    padding: 0 20px;
    height: 100%;
    max-height: 60vh;
    overflow-y: scroll;
  }
  /deep/.el-dialog{
  background-color: #eeeee2;
}
/deep/.el-dialog__body{
  padding: 0px 20px;
}


}
</style>